import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import DeleteDestinationLink from "v2/components/responsive/DeleteDestinationLink";
import DuplicateDestinationLink from "v2/components/responsive/DuplicateDestinationLink";
import MoveDestinationLink from "v2/components/responsive/MoveDestinationLink";
import SendHelpLink from "v2/components/responsive/SendHelpLink";
import CancelDestinationLink from "v2/components/responsive/CancelDestinationLink";

const DestinationActionsDropup = (props) => {
  const className = classnames(
    "dropup", "erg-inline-block", "DestinationActionsDropup",
    "NoOutlineOnFocus", props.className);
  return (
    <div className={className}>
      <a
        aria-expanded={false}
        aria-haspopup
        className="erg-add-link"
        data-toggle="dropdown"
        href="#"
        id="destination-actions-dropup">
        <i className="fa fa-cog" />Actions
        <span className="caret erg-margin-left-5" />
      </a>
      <ul
        aria-labelledby="destination-actions-dropup"
        className="dropdown-menu">
        {props.editable && <MoveDestinationLink component="li" />}
        {props.editable && <DuplicateDestinationLink component="li" />}
        <SendHelpLink component="li" />
        {props.editable && <CancelDestinationLink component="li" />}

        {props.editable && <li className="divider" role="separator" />}
        {props.editable && <DeleteDestinationLink component="li" />}
      </ul>
    </div>
  );
};

DestinationActionsDropup.propTypes = {
  className: PropTypes.string,
  editable: PropTypes.bool,
};

export default DestinationActionsDropup;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationActionsDropup.js
 **/